import {FiPlus} from "react-icons/fi";
import {Link} from "react-router";

import {Button} from "@/components/button/Button.tsx";
import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {Icon} from "@/components/icon/Icon.tsx";
import {ANALYZER} from "@/lib/featureFlags.ts";

export const ManualCreateButton = () => {
  const {user, userHasFeature} = useCurrentUserContext();
  const assistantEnabled = userHasFeature(ANALYZER);

  if (!user?.has_write_access) {
    return null;
  }

  return (
    <Button as={Link} to="/checks/create" variant={assistantEnabled ? "ghost" : "secondary"}>
      <Icon icon={FiPlus} />
      <span>{assistantEnabled ? "Create Manually" : "Create Check"}</span>
    </Button>
  );
};
